import { Handle, NodeProps } from "reactflow";
import type { ReactNode } from "react";
import cn from "classnames";
import { twMerge } from "tailwind-merge";
import Conditional from "./Conditional";
import Label from "./Label";

export default function BaseNode(
  props: {
    label: string;
    icon?: ReactNode;
    children?: ReactNode;
    className?: string;
  } & NodeProps,
) {
  return (
    <div className="max-w-base-node">
      <Conditional data={props.data} />
      <div
        className={twMerge(
          "bg-white",
          "cursor-pointer",
          "rounded-xl",
          "shadow-depth-200",
          ["transition-colors", "duration-300", "ease-in-out"],
          "p-3",
          ["flex", "flex-col", "gap-5"],
          props.className,
        )}
      >
        <Label label={props.label} icon={props.icon} />
        {props.children}
      </div>

      {props.targetPosition && (
        <Handle
          type="target"
          position={props.targetPosition}
          isConnectable={props.isConnectable}
          className={cn({ "opacity-0": !props.isConnectable })}
        />
      )}
      {props.sourcePosition && (
        <Handle
          type="source"
          position={props.sourcePosition}
          isConnectable={props.isConnectable}
          className={cn({ "opacity-0": !props.isConnectable })}
        />
      )}
    </div>
  );
}
